import api from '@/libs/axiosInstance';
import type { ApiResponse, GoogleDrivePermission } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

interface ListPermissionsResponse {
  permissions: GoogleDrivePermission[];
}

const fetchDrivePermissions = async (): Promise<GoogleDrivePermission[]> => {
  const response = await api.get<ApiResponse<ListPermissionsResponse>>(
    '/dashboard/integrations/google-drive/permissions'
  );

  if (response.data.success && response.data.data) {
    return response.data.data.permissions;
  }

  throw new Error(response.data.message || 'Failed to fetch Google Drive permissions');
};

export const useDrivePermissionsQuery = (enabled: boolean = true) => {
  return useQuery<GoogleDrivePermission[], Error>({
    queryKey: ['drive', 'permissions'],
    queryFn: fetchDrivePermissions,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};
